import { render, staticRenderFns } from "./NumberInputTouchPointComponent.vue?vue&type=template&id=2c151542"
import script from "./NumberInputTouchPointComponent.vue?vue&type=script&lang=ts"
export * from "./NumberInputTouchPointComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports